// @ts-check
import { Media } from "./media";
export class Category {
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
this.controller = new AbortController();
this.cleanups = [];
this.evtHandlers = [];

this.m = this.main = main;
this.state = state;
//used component
this.media = new Media(main,null,this);
//
/**@type {boolean}*/this.isPartial = false;//when using isPartial
/**@type {any|null}*/this.category$=null;
/**@type {any[]|null}*/this.categories$=null;
/**@type {any[]}*/this.displayCategories = [];
/**@type {string[]}*/this.parentCategoryTitles = [];//for creating new category and assigning parent

}//
async setDisplay(){
if(this.state.stateObject){
this.categories$ = this.state.stateObject.categories;
if(this.state.type=='list'){
//do nothing
}else{
if(this.state.type=='new' && this.state.id==-1){
this.category$ = this.getNewCategory();
}else if(this.state.type=='edit'){
this.category$ = this.state.stateObject.category;
}
}
}//
//step 2
if(this.categories$){
this.displayCategories = this.categories$;
if(this.state.type=='new' || this.state.type=='edit'){
this.parentCategoryTitles = [];
for(let c of this.displayCategories){
if(c.id==this.category$.id){continue;}//cant set parent name to yours
if(c.id==this.category$.parentId){
    this.category$.parent = c;
}
this.parentCategoryTitles.push(c.title);
}
}
}

}//func
async getListTemplate(){
await this.setDisplay();
let $this = this;//cu
    //get handles
    //
this.categorySection=this.main.pbu.createElement('main',['category-component']);
this.categorySection.innerHTML =
`
<section>
<div class="container">
<header>
<a type="button" href="${this.main.getLink('category',this.state.postType,'new',-1)}" class="btn btn-primary new-category sp-admin sp-route-link">Add Category </a> 
</header>

<div class="d-flex justify-content-end">
<form class="row g-3">
${this.main.pbu.createFormControl({clasz:['search-term'],divClasz:['col-auto'],placeholder:'search',serialize:true})}
<div class="col-auto">
<button id="searchButton" type="button" class="btn btn-primary mb-3">Search</button>
</div>
</form>
</div>

<section class="sp-table category-list-table">
</section>
</div>

</section>
`;

this.searchTermControl = this.categorySection.querySelector('input.search-term');
this.searchPostsButton = this.categorySection.querySelector('#searchButton');
this.categoryListTableSection = this.categorySection.querySelector('.category-list-table');
updateView();
addEvents();
this.cleanups.push(()=>{$this = null;});
return this.categorySection;

function updateView(){
$this.setListTable();
}//inner

function addEvents(){
$this.main.pbu.listen($this.searchPostsButton,'click',()=>{
    $this.searchCategories($this.searchTermControl.value);
},$this);
}//inner
}//func

async getFormTemplate2(){
await this.setDisplay();
let $this = this;//cu -d
let c =this.category$;//cu -d
this.categorySection= this.main.pbu.createElement('main',['category']);
this.main.pbu.appendChild(this.categorySection,
`
<section">
<form name="categoryForm" id="categoryForm" class="w-50 m-auto">
${this.main.pbu.createFormControl({title:"Title",value:c.title,clasz:['title','sp-validation-required'],serialize:true})}
${this.main.pbu.createFormControl({title:"Description",value:c.description,clasz:['description'],serialize:true})}
${this.main.pbu.createSelectElement({title:"Parent",value:c.parent?.id,default:'None',postItems:[...this.categories$],clasz:['parent'],serialize:true})}
<div class="mb-3 row">
<div class="col-md-4 featured-image-trigger d-none"></div>
<div class="col-md-8 featured-image card ${this.main.pbu.showIf(c.featuredImageUrl)}">
<img src="${c.featuredImageUrl}" class="main-media card-img-top" style="max-height: 50vh;"/>
<div class="delete-media mt-2"></div>
</div>

</div>
</form>
</section>
`
);

this.categoryTitleControl = this.categorySection.querySelector('input.title');
this.categoryDescriptionControl = this.categorySection.querySelector('input.description');
this.categoryParentSelector = this.categorySection.querySelector('select.parent');//<select>
//image
this.featuredImageTrigger = this.categorySection.querySelector('div.featured-image-trigger');
this.featuredImageDiv = this.categorySection.querySelector('div.featured-image');

this.main.media.getMediaTrigger('image',this.featuredImageDiv).then(r=>{
    this.main.pbu.replace(this.featuredImageTrigger,r,true);
});

await updateView();
addEvents();
return this.categorySection;

async function updateView(){
}//inner
async function addEvents(){
}//inner


}//func

async getFormTemplate(){
await this.setDisplay();
let $this = this;//cu -d
let c =this.category$;//cu -d
this.categorySection= this.main.pbu.createElement('main',['category']);
this.main.pbu.appendChild(this.categorySection,
`
<section">
<form name="categoryForm" id="categoryForm" class="w-50 m-auto">
${this.main.pbu.createFormControl({title:"Title",value:c.title,clasz:['title','sp-validation-required'],serialize:true})}
${this.main.pbu.createFormControl({title:"Description",value:c.description,clasz:['description'],serialize:true})}
${this.main.pbu.createSelectElement({title:"Parent",value:c.parent?.id,default:'None',postItems:[...this.categories$],clasz:['parent'],serialize:true})}
<div class="mb-3 row featured-image">

</div>
</form>
</section>
`
);

this.categoryTitleControl = this.categorySection.querySelector('input.title');
this.categoryDescriptionControl = this.categorySection.querySelector('input.description');
this.categoryParentSelector = this.categorySection.querySelector('select.parent');//<select>
this.featuredImageDiv = this.categorySection.querySelector('div.featured-image');
await updateView();
addEvents();
return this.categorySection;

async function updateView(){
$this.m.pb.getImageBlock({v:{src:c.featuredImageUrl}}).then(r=>$this.m.pbu.replace($this.featuredImageDiv,r.querySelector('div.main-media-container')));
}//inner
async function addEvents(){
}//inner


}//func

async setListTable(){
let titles = ["Title","Description","Post Type"];//cu -d
let posts = [];//cu
let p = null;
for(let c of this.displayCategories){
p = {
id:c.id,
href:this.main.getHomeLink('category',c.postType,'postcategory',c.title,c.id),
titles:[c.title,c.description,c.postType],
editHref:this.main.getLink('category',c.postType,'edit',c.id),
deleteHref:``
};
posts.push(p);
}//for
let menuTable = await this.main.pbu.createTable({username:this.state.username,titles:titles,posts:posts});//cu -d
this.main.pbu.replace(this.categoryListTableSection,menuTable);
this.cleanups.push(()=>{titles = p = posts = menuTable = null;});
}//func
/**
 * 
 * @param {string} searchTerm 
 */
searchCategories(searchTerm) {
if(!this.main.vu.validate(this.searchTermControl)){
    return;
}
let regex = new RegExp(`${searchTerm}`, "i");
this.displayCategories = this.categories$.filter(i=>regex.test(i.title));
this.setListTable();
}//func

async save(){
if(!this.main.vu.validate(this.categoryTitleControl,this.categoryDescriptionControl)){
    return;
}
let title = this.categoryTitleControl.value;
let parentId = this.categoryParentSelector.value;
//
let category ={
id:this.category$.id,
title:title,
slug:title.toLowerCase(),
description:this.categoryDescriptionControl.value,
postType:this.state.postType,
featuredImageUrl:this.featuredImageDiv.querySelector('.main-media')?.src||'',
postIds:[],
parentId:this.main.utils.isNull(parentId)?null:parentId,
};
this.main.setTenant(category);
this.main.log(category,'Category.saveCategory(): Before submit');
let r = await this.main.fu.fetch({
link:this.main.fu.getApi(this.state.url),
body:JSON.stringify(category),
isModal:this.state.isModal,
isOffCanvas:this.state.isOffCanvas
});
if(r>0){
    this.state = this.m.replaceState(this.category$,this.state,r);
    if(this.isPartial){
        category.id = r;
        return category;
    }else{
        this.main.utils.notify('Saved',{level:0});
    }
}
this.main.utils.finilizeSave(this);
}//func

//######
getNewCategory(){
return {
id:-1,
title:"",
slug:"",
description:"",
postType: "",
featuredImageUrl:"",
postIds:[],
parentId:null,
creationDate:"",
lastUpdate:"",
username:"",
tenantId:-1,
tenantUuid:""
};
}//func
getItems(){
    return this.categories$;
}
/**
 * 
 * @param {any} items 
 */
async setItems(items){
this.state.stateObject.categories = items;
await this.setDisplay();
}
}//class
